import {getCopilotSpacePath} from '@github-ui/copilot-chat-helpers/custom-copilots-helpers'
import type {SuggestedSpaceTeamCollaborator, SuggestedSpaceUserCollaborator} from '@github-ui/copilot-chat-types'
import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Input {
  query: string
  spaceOwner: string
  spaceId: number
  allUsers: boolean
}

interface GetSuggestedCollaboratorsResponse {
  suggestions: Array<{user: SuggestedSpaceUserCollaborator} | {team: SuggestedSpaceTeamCollaborator}>
}

export const useSuggestedSpaceCollaborators = ({input}: {input: Input}) => {
  const {data, ...rest} = useQuery({
    queryKey: ['suggestedSpaceCollaborators', input],
    queryFn: async () => {
      const spacePath = getCopilotSpacePath({
        id: input.spaceId,
        owner: input.spaceOwner,
      })

      const url = input.allUsers
        ? `${spacePath}/suggested_collaborators?q=${encodeURIComponent(input.query)}&all_users=true`
        : `${spacePath}/suggested_collaborators?q=${encodeURIComponent(input.query)}`

      const response = await verifiedFetchJSON(url)

      if (!response.ok) {
        throw new Error('Failed to fetch suggested collaborators')
      }

      const result = (await response.json()) as GetSuggestedCollaboratorsResponse

      return result.suggestions.map(suggestion => {
        if ('user' in suggestion) {
          const actor_type = 'user'
          return {
            ...suggestion.user,
            //isCollaborator: true, input.allCollaborators?.has(actorIdentifier({id: suggestion.user.id, actorType})) ?? false,

            actor_type,
          } as const
        }

        if ('team' in suggestion) {
          const actor_type = 'team'
          return {
            ...suggestion.team,
            //isCollaborator: true, input.allCollaborators?.has(actorIdentifier({id: suggestion.team.id, actorType})) ?? false,

            actor_type,
          } as const
        }

        throw new Error(
          `suggestion has a value, but the types suggest this should not be possible. Did we account for all possible options properly in the typings?`,
        )
      })
    },
    enabled: Boolean(input.query),
  })

  return {
    data,
    ...rest,
  }
}
